export default "__VITE_ASSET__BBPetr9p__"